import { autocomplete }  from '@algolia/autocomplete-js';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { createRedirectUrlPlugin } from '@algolia/autocomplete-plugin-redirect-url';
import algoliasearch from "algoliasearch/lite";

export function startAutocomplete(algoliaAppId, algoliaApiSearchKey, suggestionsIndex, trackingEnabled) {
    const searchClient = algoliasearch(algoliaAppId, algoliaApiSearchKey);
    const querySuggestionsPlugin = createQuerySuggestionsPlugin({
        searchClient,
        indexName: suggestionsIndex
    });

    const redirectUrlPlugin = createRedirectUrlPlugin();
    const searchPageURL = "/search/";
    let lastActiveItemQuery = '';

    if ($("#autocomplete").length) {
        autocomplete({
            container: "#autocomplete",
            sourceId: suggestionsIndex,
            openOnFocus: true,
            plugins: [querySuggestionsPlugin, redirectUrlPlugin],
            insights: trackingEnabled,
            onSubmit({ state }) {
                window.location.href = searchPageURL + state.query;
            },
            onStateChange({ state }) {
                if (state.activeItemId !== null) {
                    lastActiveItemQuery = state.collections[1].items[state.activeItemId].query;
                }
                if (
                    !state.isOpen &&
                    state.query.length > 0 &&
                    state.query === lastActiveItemQuery
                ) {
                    window.location.href = searchPageURL + state.query;
                }
            },
        });
    }
}
